export class ConfigLoadError extends Error {
  public readonly cause: unknown;

  constructor(cause?: unknown) {
    super('Failed to load application configuration.');
    this.name = 'ConfigLoadError';
    this.cause = cause;
  }
}

const CONFIG_FAILURE_MESSAGE = 'Application configuration could not be loaded. Please contact your system administrator.';
const GENERIC_FAILURE_MESSAGE = 'The application could not be started. Please contact your system administrator.';

export function getStartupFailureMessage(error: unknown): string {
  return error instanceof ConfigLoadError
    ? CONFIG_FAILURE_MESSAGE
    : GENERIC_FAILURE_MESSAGE;
}

export function renderStartupFailure(error: unknown): void {
  const host = document.querySelector('app-root') ?? document.body;
  const container = document.createElement('main');
  const heading = document.createElement('h1');
  const message = document.createElement('p');

  container.style.display = 'grid';
  container.style.minHeight = '100vh';
  container.style.placeItems = 'center';
  container.style.padding = '24px';
  container.style.boxSizing = 'border-box';
  container.style.backgroundColor = '#f5f7fa';
  container.style.color = '#1f2933';
  container.style.fontFamily = 'Roboto, sans-serif';
  container.style.textAlign = 'center';

  heading.textContent = 'Startup failed';
  heading.style.margin = '0 0 12px';
  heading.style.fontSize = '1.75rem';
  heading.style.fontWeight = '500';

  message.textContent = getStartupFailureMessage(error);
  message.style.margin = '0';
  message.style.maxWidth = '32rem';
  message.style.lineHeight = '1.5';

  container.append(heading, message);
  host.replaceChildren(container);
}